var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-tooltip',{attrs:{"placement":"top"}},[_c('template',{slot:"title"},[_c('span',[_vm._v(_vm._s(_vm.item.Nick))])]),_c('a-avatar',{attrs:{"src":_vm.$gestios.avatars(_vm.item.ID)}})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }